module.exports = __webpack_public_path__ + "img/avatar_2.29db8949.png";